import { Card } from '@/shared/components/Card';

interface Project {
  name: string;
  href: string;
  description: string;
}

const projects: Project[] = [
  {
    name: 'Chameleon',
    href: 'https://github.com/decisivestrike/chameleon',
    description:
      'Highly customizable Wayland shell written in Rust with gtk4-rs and Tokio.',
  },
  {
    name: 'Catacomb',
    href: 'https://github.com/decisivestrike/catacomb',
    description: 'Maze and cave generator. Will be gpu accelerated later.',
  },
  {
    name: 'Mafia',
    href: 'https://github.com/sh1nsh1/mafia-mobile',
    description: 'Mafia game. WIP',
  },
];

export default function ProjectsSection() {
  return (
    <section className="py-5">
      <h2 className="mb-2 text-center">Awesome Projects</h2>
      <div className="flex flex-wrap justify-center gap-6 p-5">
        {projects.map(project => (
          <ProjectCard {...project} key={project.name} />
        ))}
      </div>
    </section>
  );
}

function ProjectCard({ name, href, description }: Project) {
  return (
    <Card>
      <h3 className="mb-2">
        <a href={href} target="_blank" rel="noopener noreferrer">
          {name}
        </a>
      </h3>
      <p className="line-clamp-2 text-sm">{description}</p>
    </Card>
  );
}
